import React from "react";
import Facility from "./Facility";
import './FacilitiesList.scss';

const FacilitiesList = ({ facilities, searchParams }) => {
  const offset = searchParams.has('offset') ? parseInt(searchParams.get('offset')) : 0;
  return (
    <div className="FacilitiesList">
      {facilities.map((facility, index) =>
        <Facility
          resultNum={index + offset + 1}
          facility={facility}
          key={facility.id}
        />
      )}
    </div>
  );
};

export default FacilitiesList;
